import { create } from "zustand";
import { OperationQueue } from "@/utils/queue";
import { Subscription } from "@/models/subscriptions/Subscription";
import { LegislationSubscription } from "@/models/subscriptions/LegislationSubscription.ts";

type SubscriptionOperationStore = {
  operationQueue: OperationQueue<Subscription | LegislationSubscription | void>;
  pendingOperations: Set<string>;
  isPending: (entityPath: string) => boolean;
};

const initialState = {
  operationQueue: new OperationQueue<Subscription | LegislationSubscription | void>(),
  pendingOperations: new Set<string>(),
};

const useSubscriptionOperationStore = create<SubscriptionOperationStore>(
  (_, get) => ({
    ...initialState,
    isPending: (entityPath: string) => get().pendingOperations.has(entityPath),
  })
);

export default useSubscriptionOperationStore;
